import { render, staticRenderFns } from "./LiveRoomAllocationSet.vue?vue&type=template&id=05a57717"
import script from "./LiveRoomAllocationSet.vue?vue&type=script&lang=js"
export * from "./LiveRoomAllocationSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports